<form
  class="form animate-fade-in"
  #userSignatureForm="ngForm"
  name="userSignatureForm"
  (ngSubmit)="onFinalSubmit(userSignatureForm)"
>
  <div>
    <div class="sm-mb-4 sm-text-center">
      <h1 class="heading-text">Add your signature</h1>
      <p class="sm-text-default-text sm-text-center" i18n>
        Draw your signature in the field below (don't worry, you can change it later!). You'll use your
        signature to sign-off and approve forms in Dashpivot.
      </p>
    </div>

    <div class="form-group sm-my-2">
      <input type="hidden" [(ngModel)]="model.signature" required name="signature" #signature="ngModel" />
      <cc-signature-pad
        class="signature-pad"
        *ngIf="imageSignature"
        [class.error-state]="hasSignatureError(signature)"
        [src]="imageSignatureUrl"
        [height]="96"
        [width]="310"
      ></cc-signature-pad>
      <cc-signature-pad
        class="signature-pad"
        *ngIf="!imageSignature"
        [class.signature-placeholder-image]="!signatureInProgress && !imageSignature"
        [class.error-state]="hasSignatureError(signature)"
        [options]="signaturePadOptions"
        (start)="drawStart()"
        (end)="drawComplete($event)"
      ></cc-signature-pad>
    </div>
    <div class="sm-my-2 d-flex justify-content-between upload-signature">
      <div class="sm-mt-1 sm-text-xs sm-text-default-red" i18n *ngIf="hasSignatureError(signature)">
        Required
      </div>

      <span i18n *ngIf="!signatureInProgress && !imageSignature">
        or
        <label class="default-label default-label">
          <a class="text-link"><u>upload your signature</u></a>
          <i class="cc-icon cc-icon-spinner-fw" *ngIf="signatureUploading"></i>
          <input type="file" name="file" class="d-none" (change)="uploadSignature($event)" accept="image/*" />
        </label>
      </span>

      <button
        class="px-2 py-1 ml-auto btn btn-sm cc-btn-subtle-gray help-text fadeIn"
        id="reset-signature-button"
        type="button"
        title="Clear"
        i18n-title="Clear"
        (click)="clearSignature()"
        *ngIf="signatureInProgress || imageSignature"
      >
        <i class="mr-1 cc-icon cc-icon-undo"></i><span>Reset</span>
      </button>
    </div>
    <button
      type="submit"
      class="py-3 btn btn-submit btn-primary btn-block"
      ccSegmentCTA
      ctaContext="Sign up Page Signature"
      [ccBusyButton]="isProcessing"
      [class.sm-opacity-60]="!userSignatureForm.valid || hasSignatureError(signature)"
      [class.disabled]="!userSignatureForm.valid || hasSignatureError(signature)"
    >
      <span i18n>Get started</span>
    </button>
  </div>
</form>
